export const rules = {
  device_name: [
    { required: true, message: "请输入", trigger: "blur" },
  ],
  device_code: [
    { required: true, message: "请选择区域", trigger: "change" },
  ],
  device_id: [
    { required: true, message: "请输入", trigger: "change" },
  ],
  device_admin: [
    { required: true, message: "请输入", trigger: "change" },
  ],
  dev_code: [
    { required: true, message: "请输入", trigger: "change" },
  ],
  model_id: [
    { required: true, message: "请输入", trigger: "change" },
  ],
  brand_id: [
    { required: true, message: "请输入", trigger: "change" },
  ]
}